import { personsAsObject as pers } from './persons.api';
import { categoriesAsObject as cats } from './categories.api';
import { locationsAsObject as locs } from './locations.api';
import { delay } from '../../utils/helpers';

/*
export interface IOrganization {
	_id: string;
	name: string; // org 210a
	locations: ILocation[]; // связь с локациями(адресами), минимум 1 адрес д.б., org 515a
	categories: ICategory[]; // org 550a - категории для фильтра на карте
	alt_names?: string[]; // org 410a (необязатльно)
	info: string; // org 300a
	persons?: IPerson[]; // связь с персонами (необязатльно), org 500a
	organizations?: IOrganization[]; // связь с другими организациями (необязатльно), org 510a
	links?: ILink[]; // ссылки по теме (необязатльно), org 856u (И2=0)
	gallery?: string[]; // ссылки на картинки (необязательно!), org 856u (И2=1) для галереи-карусели
}
*/

let organizations = [
  {
    _id: '1',
    name: 'Дом ветеранов',
    locations: [locs.loc1._id],
    categories: [cats.cat1._id, cats.cat11._id],
    alt_names: ['Дом номер 2', 'Дом номер 3'],
    info: 'Частное благотворительное общество, основанное в 1898 году под покровительством императрицы Марии Фёдоровны, супруги Александра III. Со временем взяло на себя функции центрального органа, возглавившего дело призрения, обучения и воспитания глухонемых. Имело отделения во многих городах России.В Санкт-Петербурге Попечительство заботилось о Доме призрения и Школе глухонемых (Мариинская школа-колония в Мурзинке), а кроме того, в 1902-1915 годах издавало ежемесячный журнал «Вестник Попечительства императрицы Марии Фёдоровны о глухонемых» (типография находилась по адресу: Гороховая ул., 18). Патронируемые Попечительством учреждения: Дом призрения и школа глухонемых (Мариинская); Мастерские столярного и переплетного мастерства при Мариинской школе; Дом призрения для престарелых и неспособных к труду глухонемых; Амбулатория для приходящих в здании Училища глухонемых; Бюро для наведения справок о семейном и материальном положении частных глухонемых, обращавшихся за помощью. В 1917 году перешло в ведение Управления Мариинскими благотворительными заведениями, а в 1918 году было ликвидировано.',
    persons: [pers.actor._id, pers.doctor._id],
    organizations: ['2'],
    links: [
      'Попечительство императрицы Марии Фёдоровны о глухонемых : [историческая справка]$http://encspb.ru/object/2815811872?lc=ru',
      'Векслер А.Ф. Попечитель // Родина. 1992. № 11/12. С. 123-128$https://ya.ru',
      'Просто о важном. Издание 5. Стр.55-56',
    ],
    gallery: [
      'https://charity-old.lbspb.ru/system/pages/000/010/47/images/small/cf27cb641f64f57e40998791937d3eadd032932d.jpg?1648817389',
      'https://charity-old.lbspb.ru/system/pages/000/013/55/images/small/d34fd6d0472be9d7ccc415d86404e582df3b2fa5.jpg?1701963195',
      'https://charity-old.lbspb.ru/system/pages/000/011/85/images/small/57ab31f63a1402542cb132ffbe44def4d3cb2a23.jpg?1659707618',
    ],
  },
  {
    _id: '2',
    name: 'Дом пионеров',
    locations: [locs.loc2._id],
    categories: [cats.cat3._id, cats.cat12._id],
    alt_names: ['Дом номер 22', 'Дом номер 33'],
    info: 'Создается под председательством К. К. Грота (1815-1897) на базе Главного Попечительства для пособия нуждающимся семействам воинов, учрежденного во время русско-турецкой войны. Для слепых солдат открываются ремесленные училища-интернаты. Слепые других сословий также начинают активно обращаться с просьбами в это попечительство. Становится очевидно, что необходимо создавать постоянное общество и заботиться об участи всех слепых. Одна из основных целей нового Попечительства — подготовка слепых к самостоятельной трудовой жизни.',
    persons: [pers.physics._id, pers.engineer._id],
    organizations: ['1'],
    links: [
      'Попечительство императрицы Марии Фёдоровны о глухонемых : [историческая справка]$http://encspb.ru/object/2815811872?lc=ru',
      'Векслер А.Ф. Попечитель // Родина. 1992. № 11/12. С. 123-128$https://ya.ru',

      'Просто о важном. Издание 5. Стр.55-56',
    ],
    gallery: [
      'https://charity-old.lbspb.ru/system/pages/000/010/47/images/small/cf27cb641f64f57e40998791937d3eadd032932d.jpg?1648817389',
    ],
  },
  {
    _id: '3',
    name: 'Дом призраков',
    locations: [locs.loc3._id],
    categories: [cats.cat1._id, cats.cat13._id],
    info: 'Создается под председательством К. К. Грота (1815-1897) на базе Главного Попечительства для пособия нуждающимся семействам воинов, учрежденного во время русско-турецкой войны. Для слепых солдат открываются ремесленные училища-интернаты. Слепые других сословий также начинают активно обращаться с просьбами в это попечительство. Становится очевидно, что необходимо создавать постоянное общество и заботиться об участи всех слепых. Одна из основных целей нового Попечительства — подготовка слепых к самостоятельной трудовой жизни.',
    gallery: [
      'https://charity-old.lbspb.ru/system/pages/000/010/47/images/small/cf27cb641f64f57e40998791937d3eadd032932d.jpg?1648817389',
      'https://charity-old.lbspb.ru/system/pages/000/011/85/images/small/57ab31f63a1402542cb132ffbe44def4d3cb2a23.jpg?1659707618',
    ],
    links: ['Просто о важном. Издание 5. Стр.55-56'],
  },
  {
    _id: '4',
    name: 'Музей №1',
    locations: [locs.loc3._id],
    categories: [cats.cat2._id, cats.cat15._id, cats.cat14._id],
    info: 'Создается под председательством К. К. Грота (1815-1897) на базе Главного Попечительства для пособия нуждающимся семействам воинов, учрежденного во время русско-турецкой войны. Для слепых солдат открываются ремесленные училища-интернаты. Слепые других сословий также начинают активно обращаться с просьбами в это попечительство. Становится очевидно, что необходимо создавать постоянное общество и заботиться об участи всех слепых. Одна из основных целей нового Попечительства — подготовка слепых к самостоятельной трудовой жизни.',
    gallery: [
      'https://charity-old.lbspb.ru/system/pages/000/010/47/images/small/cf27cb641f64f57e40998791937d3eadd032932d.jpg?1648817389',
      'https://charity-old.lbspb.ru/system/pages/000/011/85/images/small/57ab31f63a1402542cb132ffbe44def4d3cb2a23.jpg?1659707618',
    ],
  },
  {
    _id: '5',
    name: 'Музей №2',
    locations: [locs.loc1._id, locs.loc4._id],
    categories: [cats.cat3._id, cats.cat11._id, cats.cat21._id],
    info: 'Создается под председательством К. К. Грота (1815-1897) на базе Главного Попечительства для пособия нуждающимся семействам воинов, учрежденного во время русско-турецкой войны. Для слепых солдат открываются ремесленные училища-интернаты. Слепые других сословий также начинают активно обращаться с просьбами в это попечительство. Становится очевидно, что необходимо создавать постоянное общество и заботиться об участи всех слепых. Одна из основных целей нового Попечительства — подготовка слепых к самостоятельной трудовой жизни.',
    gallery: [
      'https://charity-old.lbspb.ru/system/pages/000/010/47/images/small/cf27cb641f64f57e40998791937d3eadd032932d.jpg?1648817389',
      'https://charity-old.lbspb.ru/system/pages/000/011/85/images/small/57ab31f63a1402542cb132ffbe44def4d3cb2a23.jpg?1659707618',
    ],
  },
  {
    _id: '6',
    name: 'Музей №3',
    locations: [locs.loc5._id, locs.loc6._id],
    categories: [cats.cat2._id, cats.cat12._id, cats.cat22._id],
    info: 'Создается под председательством К. К. Грота (1815-1897) на базе Главного Попечительства для пособия нуждающимся семействам воинов, учрежденного во время русско-турецкой войны. Для слепых солдат открываются ремесленные училища-интернаты. Слепые других сословий также начинают активно обращаться с просьбами в это попечительство. Становится очевидно, что необходимо создавать постоянное общество и заботиться об участи всех слепых. Одна из основных целей нового Попечительства — подготовка слепых к самостоятельной трудовой жизни.',
    gallery: [
      'https://charity-old.lbspb.ru/system/pages/000/010/47/images/small/cf27cb641f64f57e40998791937d3eadd032932d.jpg?1648817389',
      'https://charity-old.lbspb.ru/system/pages/000/011/85/images/small/57ab31f63a1402542cb132ffbe44def4d3cb2a23.jpg?1659707618',
    ],
  },
  {
    _id: '7',
    name: 'Институт Главный',
    locations: [locs.loc7._id],
    categories: [cats.cat1._id, cats.cat13._id, cats.cat23._id],
    info: 'Создается под председательством К. К. Грота (1815-1897) на базе Главного Попечительства для пособия нуждающимся семействам воинов, учрежденного во время русско-турецкой войны. Для слепых солдат открываются ремесленные училища-интернаты. Слепые других сословий также начинают активно обращаться с просьбами в это попечительство. Становится очевидно, что необходимо создавать постоянное общество и заботиться об участи всех слепых. Одна из основных целей нового Попечительства — подготовка слепых к самостоятельной трудовой жизни.',
  },
  {
    _id: '8',
    name: 'Институт Второй',
    locations: [locs.loc8._id],
    categories: [cats.cat3._id, cats.cat14._id, cats.cat24._id],
    info: 'Создается под председательством К. К. Грота (1815-1897) на базе Главного Попечительства для пособия нуждающимся семействам воинов, учрежденного во время русско-турецкой войны. Для слепых солдат открываются ремесленные училища-интернаты. Слепые других сословий также начинают активно обращаться с просьбами в это попечительство. Становится очевидно, что необходимо создавать постоянное общество и заботиться об участи всех слепых. Одна из основных целей нового Попечительства — подготовка слепых к самостоятельной трудовой жизни.',
  },
  {
    _id: '9',
    name: 'Лечебница им.Ленина',
    locations: [locs.loc9._id],
    categories: [cats.cat3._id, cats.cat15._id],
    info: 'Создается под председательством К. К. Грота (1815-1897) на базе Главного Попечительства для пособия нуждающимся семействам воинов, учрежденного во время русско-турецкой войны. Для слепых солдат открываются ремесленные училища-интернаты. Слепые других сословий также начинают активно обращаться с просьбами в это попечительство. Становится очевидно, что необходимо создавать постоянное общество и заботиться об участи всех слепых. Одна из основных целей нового Попечительства — подготовка слепых к самостоятельной трудовой жизни.',
  },
  {
    _id: '10',
    name: 'Здравница №1',
    locations: [locs.loc10._id],
    categories: [cats.cat3._id],
    info: 'Создается под председательством К. К. Грота (1815-1897) на базе Главного Попечительства для пособия нуждающимся семействам воинов, учрежденного во время русско-турецкой войны. Для слепых солдат открываются ремесленные училища-интернаты. Слепые других сословий также начинают активно обращаться с просьбами в это попечительство. Становится очевидно, что необходимо создавать постоянное общество и заботиться об участи всех слепых. Одна из основных целей нового Попечительства — подготовка слепых к самостоятельной трудовой жизни.',
  },
];

// возвращает минимально необходимую информацию для показа на карте (_id, name, locations, categories)
const fetchAll = async () => {
  // if (CONFIG.IS_SERVER) {
  // 	const {data} = await httpService.get(CONFIG.API_URL + "organization")
  // 	return data
  // } else {
  await delay(50);
  let newOrgs = [];
  organizations.forEach((o) =>
    newOrgs.push({ _id: o._id, name: o.name, locations: o.locations, categories: o.categories, persons: o.persons })
  );
  return newOrgs;
  // }
};

// возвращает полные данные об одной организации
const getById = async (id) => {
  // if (CONFIG.IS_SERVER) {
  // 	const {data} = await httpService.get(CONFIG.API_URL + "organization/" + id)
  // 	return data
  // } else {
  await delay(50);
  return organizations.find((org) => org._id === id);
  // }
};

// возвращает только список id организаций согласно поисковому запросу
const search = async (text) => {
  // if (CONFIG.IS_SERVER) {
  // 	const {data} = await httpService.get(CONFIG.API_URL + "organization/search?q=" + text)
  // 	return data
  // } else {
  await delay(50);
  let res = [];
  organizations
    .filter((o) => o.info.indexOf(text) != -1 || o.name.indexOf(text) != -1)
    .forEach((o) => {
      res.push(o._id);
    });
  return res;
  // }
};

// возвращает только список id организаций согласно поисковому запросу
const search2 = async (text) => {
  await delay(50);
  let res = [];
  organizations
    .filter((o) => o.info.indexOf(text) != -1 || o.name.indexOf(text) != -1)
    .forEach((o) => {
      res.push(o._id);
    });
  return res;
};

// const add = async (data) => {
//   await delay(50);
//   const newItem = {
//     ...data,
//     created_at: Date.now(),
//     _id: Math.random().toString(36).substr(2, 9),
//   };
//   organizations.push(newItem);
//   return newItem;
// };

// const remove = async (id) => {
//   await delay(50);
//   organizations = organizations.filter((x) => x._id !== id);
//   return id;
// };

export default {
  fetchAll,
  search,
  search2,
  getById,
  // add,
  // remove,
};
